import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Form, Select } from 'tdesign-react';
import { updateSchemaCompatibilityPolicy } from '@/services/topicService';
import { fetchPolices } from '@/slices/topicSlice';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { deal70101, toTsOptions } from '@/utils/common';

const { FormItem } = Form;

function Modal({ visible, handleClose, options, detail, commonProps, fetchPolices }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      form.reset();
      form.setFieldsValue(detail);
    }
  }, [form, visible, detail]);

  const onCancel = () => {
    handleClose();
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const { meta } = await updateSchemaCompatibilityPolicy({
          ...commonProps,
          ...fields,
        });
        // 主集群创建的资源已在灾备集群存在
        if (meta.code === 70101) {
          deal70101(meta.publicMessage, () => handleSubmit({ validateResult, fields }), {
            url: '/cluster/topic/list',
            topic: commonProps.topic,
          });
          return;
        }
        await fetchPolices(commonProps);
        handleClose();
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      header='Schema 兼容策略'
      width={550}
      onClose={onCancel}
    >
      <Form form={form} onSubmit={handleSubmit} style={{ width: '94%' }} labelWidth={140}>
        <FormItem name='schemaCompatibilityStrategy' rules={[{ required: true }]} label='兼容策略'>
          <Select options={toTsOptions(options)} clearable />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect(
  (state) => ({
    options: state.dict.schemaPolicy,
  }),
  {
    fetchPolices,
  },
)(Modal);
